import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=a14bcae2&scoped=true&"
import script from "./layout.ts?vue&type=script&lang=ts&"
export * from "./layout.ts?vue&type=script&lang=ts&"
import style0 from "./layout.less?vue&type=style&index=0&id=a14bcae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14bcae2",
  null
  
)

export default component.exports